export function filterRegistrationPlateKeys(e: React.KeyboardEvent<HTMLInputElement>) {
  if (e.key.length !== 1) {
    return;
  }

  if (e.ctrlKey || e.altKey || e.metaKey) {
    return;
  }

  if (!e.key.match(/^[A-Z0-9]$/i)) {
    e.preventDefault();
    return;
  }

  const input = e.currentTarget;

  input.setRangeText(
    e.key.toUpperCase(),
    input.selectionStart ?? 0,
    input.selectionEnd ?? 0,
    'end'
  );

  input.dispatchEvent(new Event('input', {bubbles: true}));
  e.preventDefault();
}
